<template>
    <div class="audit-list-widget">

        <div class="card">
            <h3 class="card-header">Audits</h3>
            <div class="card-body">
                <data-table
                    :show-pager="false"
                    :show-filters="false"
                    :get-items="getItems"
                    :fields="fields">
                    <template v-slot:customField="slotProps">
                        <template v-if="slotProps.row.field.key === 'actions'">
                            <b-btn size="sm"
                                   variant="secondary"
                                   @click="viewItem(slotProps.row.item)">
                                <b-icon-eye/>
                            </b-btn>
                        </template>
                        <template v-else-if="slotProps.row.field.key === 'audit'">
                            <audit-badge :audit="slotProps.row.item"/>
                        </template>
                        <template v-else>
                            {{ slotProps.row.item[slotProps.row.field.key] }}
                        </template>
                    </template>
                </data-table>
            </div>
        </div>
    </div>
</template>

<script>
import AuditBadge from '@/components/AuditBadge'

export default {
    name: 'AuditListWidget',
    components: { AuditBadge },
    props: {
        audits: Array,
    },
    data () {
        return {
            fields: [
                { key: 'audit', sortable: false, label: 'Status' },
                { key: 'actions', sortable: false, label: 'View' },
            ],
        }
    },
    methods: {
        getItems (listParams) {
            return Promise.resolve(this.audits)
        },
        viewItem (item) {
            this.$router.push(`/audit/edit/${item.id}`)
        },
    },
}
</script>

<style scoped>

</style>